// Repositorio de señales para la cartelería, en vectorial (nítidas en A4 y A3). Códigos del Reglamento General de Circulación.
// Cada señal: código, nombre, grupo, proporción alto/ancho y componente; `valor` para las que llevan cifra (velocidad, altura…).
const ROJO = "#cc0000";
const AZUL = "#003399";
const NEGRO = "#111111";
const AMARILLO = "#f5b800";

const Svg = ({ vb = "0 0 100 100", label, children }) => (
  <svg width="100%" height="100%" viewBox={vb} aria-label={label} style={{ display: "block", overflow: "visible" }}>{children}</svg>
);
// círculo de prohibición: borde blanco fino, corona roja y fondo
const Prohibicion = ({ fondo = "#fff", children }) => (
  <>
    <circle cx="50" cy="50" r="49.6" fill="#fff" stroke="#000" strokeWidth="0.4" />
    <circle cx="50" cy="50" r="43" fill={fondo} stroke={ROJO} strokeWidth="9" />
    {children}
  </>
);
const Barra = () => <line x1="19.6" y1="19.6" x2="80.4" y2="80.4" stroke={ROJO} strokeWidth="9" />;
const Obligacion = ({ children }) => (
  <>
    <circle cx="50" cy="50" r="49.6" fill="#fff" stroke="#000" strokeWidth="0.4" />
    <circle cx="50" cy="50" r="47" fill={AZUL} />
    {children}
  </>
);
const Peligro = ({ children }) => (
  <>
    <path d="M50 4 L97 90 H3 Z" fill="#fff" stroke="#000" strokeWidth="0.4" strokeLinejoin="round" />
    <path d="M50 12 L89 85 H11 Z" fill="#fff" stroke={ROJO} strokeWidth="9" strokeLinejoin="round" />
    {children}
  </>
);
const flecha = "M50 18 L74 46 H59 V82 H41 V46 H26 Z";
const octogono = Array.from({ length: 8 }, (_, i) => {
  const a = ((22.5 + 45 * i) * Math.PI) / 180;
  return `${50 + 49 * Math.cos(a)},${50 + 49 * Math.sin(a)}`;
}).join(" ");
const giro = (dcha) => (
  <g transform={dcha ? undefined : "translate(100 0) scale(-1 1)"}>
    <path d="M40 80 V50 H60" fill="none" stroke={NEGRO} strokeWidth="9" strokeLinejoin="round" />
    <path d="M58 35 L77 50 L58 65 Z" fill={NEGRO} />
  </g>
);

export const SenalR307 = () => (
  <Svg label="R-307: parada y estacionamiento prohibidos">
    <circle cx="50" cy="50" r="49.6" fill="#fff" stroke="#000" strokeWidth="0.4" />
    <circle cx="50" cy="50" r="47.5" fill={ROJO} />
    <circle cx="50" cy="50" r="34" fill={AZUL} />
    <clipPath id="r307"><circle cx="50" cy="50" r="34" /></clipPath>
    <g clipPath="url(#r307)" stroke={ROJO} strokeWidth="13">
      <line x1="10" y1="10" x2="90" y2="90" />
      <line x1="90" y1="10" x2="10" y2="90" />
    </g>
  </Svg>
);

// Garaje con la flecha de entrada, salida o ambas, dentro de una señal de prohibición
export const SenalGaraje = ({ sentido = "entrada" }) => (
  <Svg label={`Prohibida la ${sentido === "ambas" ? "entrada y salida" : sentido} del garaje`}>
    <Prohibicion>
      <g fill="none" stroke="#1e293b" strokeWidth="3.2" strokeLinejoin="round" strokeLinecap="round">
        <path d="M24 44 L50 25 L76 44" />
        <path d="M29 41 V66 H71 V41" />
        <path d="M37 66 V50 H63 V66" />
        <path d="M37 55 H63 M37 60.5 H63" strokeWidth="2" />
      </g>
      <g fill="#1e293b" stroke="#1e293b" strokeWidth="3.4" strokeLinecap="round">
        {sentido !== "salida" && <><path d="M72 76 H54" /><path d="M54 76 l6 -5 v10 z" strokeWidth="1" /></>}
        {sentido !== "entrada" && <><path d="M28 76 H46" /><path d="M46 76 l-6 -5 v10 z" strokeWidth="1" /></>}
      </g>
      <Barra />
    </Prohibicion>
  </Svg>
);

const panel = (fondo, borde, children, label) => (
  <Svg vb="0 0 200 100" label={label}>
    <rect x="0.5" y="0.5" width="199" height="99" rx="6" fill="#fff" stroke="#000" strokeWidth="0.6" />
    <rect x="4" y="4" width="192" height="92" rx="4" fill={fondo} stroke={borde} strokeWidth={borde ? 6 : 0} />
    {children}
  </Svg>
);
const rotulo = (texto, y, tam, color = NEGRO, x = 100) => (
  <text x={x} y={y} textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontWeight="800" fontSize={tam} fill={color}>{texto}</text>
);

export const GRUPOS_SENALES = { prohibicion: "Prohibición", obligacion: "Obligación y prioridad", peligro: "Peligro", paneles: "Paneles y balizas" };

export const BIBLIOTECA = {
  r101: { codigo: "R-101", nombre: "Entrada prohibida", grupo: "prohibicion", C: () => (
    <Svg label="R-101: entrada prohibida">
      <circle cx="50" cy="50" r="49.6" fill="#fff" stroke="#000" strokeWidth="0.4" />
      <circle cx="50" cy="50" r="47" fill={ROJO} />
      <rect x="18" y="40" width="64" height="20" fill="#fff" />
    </Svg>) },
  r100: { codigo: "R-100", nombre: "Circulación prohibida", grupo: "prohibicion", C: () => <Svg label="R-100: circulación prohibida"><Prohibicion /></Svg> },
  r307: { codigo: "R-307", nombre: "Parada y estacionamiento prohibidos", grupo: "prohibicion", C: SenalR307 },
  r308: { codigo: "R-308", nombre: "Estacionamiento prohibido", grupo: "prohibicion", C: () => (
    <Svg label="R-308: estacionamiento prohibido">
      <Prohibicion fondo={AZUL}><Barra /></Prohibicion>
    </Svg>) },
  r301: { codigo: "R-301", nombre: "Velocidad máxima", grupo: "prohibicion", valor: "30", etiquetaValor: "km/h", C: ({ valor }) => (
    <Svg label={`R-301: velocidad máxima ${valor} km/h`}>
      <Prohibicion>
        <text x="50" y="50" dy="0.35em" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontWeight="800"
          fontSize={String(valor || "").length > 2 ? 34 : 44} fill={NEGRO}>{valor}</text>
      </Prohibicion>
    </Svg>) },
  r302: { codigo: "R-302", nombre: "Giro a la derecha prohibido", grupo: "prohibicion", C: () => (
    <Svg label="R-302: giro a la derecha prohibido"><Prohibicion>{giro(true)}<Barra /></Prohibicion></Svg>) },
  r303: { codigo: "R-303", nombre: "Giro a la izquierda prohibido", grupo: "prohibicion", C: () => (
    <Svg label="R-303: giro a la izquierda prohibido"><Prohibicion>{giro(false)}<Barra /></Prohibicion></Svg>) },
  r305: { codigo: "R-305", nombre: "Adelantamiento prohibido", grupo: "prohibicion", C: () => (
    <Svg label="R-305: adelantamiento prohibido">
      <Prohibicion>
        <rect x="27" y="36" width="19" height="31" rx="5" fill={ROJO} />
        <rect x="54" y="36" width="19" height="31" rx="5" fill={NEGRO} />
        <rect x="30" y="41" width="13" height="7" rx="1.5" fill="#fff" /><rect x="57" y="41" width="13" height="7" rx="1.5" fill="#fff" />
      </Prohibicion>
    </Svg>) },
  r1: { codigo: "R-1", nombre: "Ceda el paso", grupo: "obligacion", C: () => (
    <Svg label="R-1: ceda el paso">
      <path d="M3 10 H97 L50 96 Z" fill="#fff" stroke="#000" strokeWidth="0.4" strokeLinejoin="round" />
      <path d="M12 15 H88 L50 87 Z" fill="#fff" stroke={ROJO} strokeWidth="9" strokeLinejoin="round" />
    </Svg>) },
  r2: { codigo: "R-2", nombre: "STOP", grupo: "obligacion", C: () => (
    <Svg label="R-2: detención obligatoria (STOP)">
      <polygon points={octogono} fill={ROJO} stroke="#fff" strokeWidth="3" />
      <text x="50" y="50" dy="0.35em" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontWeight="800" fontSize="29" fill="#fff">STOP</text>
    </Svg>) },
  r400: { codigo: "R-400", nombre: "Sentido obligatorio (gírela)", grupo: "obligacion", C: () => (
    <Svg label="R-400: sentido obligatorio"><Obligacion><path d={flecha} fill="#fff" /></Obligacion></Svg>) },
  r401: { codigo: "R-401a", nombre: "Paso obligatorio", grupo: "obligacion", C: () => (
    <Svg label="R-401a: paso obligatorio"><Obligacion><path d={flecha} fill="#fff" transform="rotate(135 50 50)" /></Obligacion></Svg>) },
  r407: { codigo: "R-407", nombre: "Vía reservada a ciclos", grupo: "obligacion", C: () => (
    <Svg label="R-407: vía reservada a ciclos">
      <Obligacion>
        <g fill="none" stroke="#fff" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="31" cy="62" r="12" /><circle cx="69" cy="62" r="12" />
          <path d="M31 62 L44 40 H62 L69 62 M44 40 L52 62 H31 M58 32 H66" />
        </g>
      </Obligacion>
    </Svg>) },
  p50: { codigo: "P-50", nombre: "Otros peligros", grupo: "peligro", C: () => (
    <Svg label="P-50: otros peligros">
      <Peligro>
        <rect x="45" y="36" width="10" height="28" rx="3" fill={NEGRO} />
        <circle cx="50" cy="73" r="5.5" fill={NEGRO} />
      </Peligro>
    </Svg>) },
  p18: { codigo: "P-18", nombre: "Obras", grupo: "peligro", C: () => (
    <Svg label="P-18: obras">
      <Peligro>
        <circle cx="45" cy="38" r="5" fill={NEGRO} />
        <path d="M44 45 L38 61 L44 64 L47 56 L52 63 L52 76 M38 61 L33 76 M45 47 L58 55" fill="none" stroke={NEGRO} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M57 54 L66 70" stroke={NEGRO} strokeWidth="3" strokeLinecap="round" />
        <path d="M58 77 Q68 64 78 77 Z" fill={NEGRO} />
      </Peligro>
    </Svg>) },
  p20: { codigo: "P-20", nombre: "Peatones", grupo: "peligro", C: () => (
    <Svg label="P-20: peatones">
      <Peligro>
        <circle cx="52" cy="36" r="5" fill={NEGRO} />
        <path d="M51 44 L46 60 L41 76 M46 60 L55 76 M50 47 L41 55 M51 47 L60 56" fill="none" stroke={NEGRO} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
      </Peligro>
    </Svg>) },
  desvio: { codigo: "Panel", nombre: "DESVÍO (voltéelo para cambiar el sentido)", grupo: "paneles", ratio: 0.5, C: () => panel(AMARILLO, null, (
    <>
      {rotulo("DESVÍO", 63, 34, NEGRO, 80)}
      <path d="M166 28 L192 50 L166 72 V59 H148 V41 H166 Z" fill={NEGRO} />
    </>), "Panel de desvío") },
  cortada: { codigo: "Panel", nombre: "CALLE CORTADA", grupo: "paneles", ratio: 0.5, C: () => panel("#fff", ROJO, (
    <>{rotulo("CALLE", 45, 30)}{rotulo("CORTADA", 78, 30)}</>), "Panel de calle cortada") },
  grua: { codigo: "Panel", nombre: "Retirada por grúa", grupo: "paneles", ratio: 0.5, C: () => panel(AZUL, null, (
    <>{rotulo("GRÚA", 58, 44, "#fff")}{rotulo("RETIRADA DE VEHÍCULOS", 84, 13, "#fff")}</>), "Panel de retirada por grúa") },
  policia: { codigo: "Panel", nombre: "POLICÍA LOCAL", grupo: "paneles", ratio: 0.5, C: () => panel(AZUL, null, (
    <>
      <rect x="4" y="38" width="192" height="24" fill="#fff" />
      {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => <rect key={i} x={4 + i * 24} y="38" width="12" height="12" fill={AZUL} />)}
      {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => <rect key={i} x={16 + i * 24} y="50" width="12" height="12" fill={AZUL} />)}
      {rotulo("POLICÍA LOCAL", 29, 22, "#fff")}{rotulo("CONTROL", 87, 20, "#fff")}
    </>), "Panel de Policía Local") },
  garaje_entrada: { codigo: "Garaje", nombre: "Entrada al garaje prohibida", grupo: "paneles", C: () => <SenalGaraje sentido="entrada" /> },
  garaje_salida: { codigo: "Garaje", nombre: "Salida del garaje prohibida", grupo: "paneles", C: () => <SenalGaraje sentido="salida" /> },
  garaje_ambas: { codigo: "Garaje", nombre: "Entrada y salida del garaje prohibidas", grupo: "paneles", C: () => <SenalGaraje sentido="ambas" /> },
  valla: { codigo: "Valla", nombre: "Valla", grupo: "paneles", ratio: 0.3, C: () => (
    <Svg vb="0 0 200 60" label="Valla">
      <rect x="1" y="1" width="198" height="58" rx="3" fill="#fff" stroke={NEGRO} strokeWidth="2" />
      <clipPath id="valla"><rect x="2" y="2" width="196" height="56" rx="2" /></clipPath>
      <g clipPath="url(#valla)">
        {[0, 1, 2, 3, 4, 5].map((i) => <path key={i} d={`M${10 + i * 40} 2 H${30 + i * 40} L${10 + i * 40} 58 H${-10 + i * 40} Z`} fill={ROJO} />)}
      </g>
    </Svg>) },
  cono: { codigo: "TB-6", nombre: "Cono", grupo: "paneles", C: () => (
    <Svg label="TB-6: cono">
      <path d="M50 4 L80 90 H20 Z" fill="#f97316" />
      <path d="M40.5 32 H59.5 L63.5 45 H36.5 Z M33.5 55 H66.5 L70.5 68 H29.5 Z" fill="#fff" />
      <rect x="10" y="88" width="80" height="8" rx="2" fill={NEGRO} />
    </Svg>) },
  flecha: { codigo: "Flecha", nombre: "Flecha (gírela)", grupo: "paneles", C: () => <Svg label="Flecha"><path d={flecha} fill={NEGRO} /></Svg> },
};
